import axios from "axios";
const BACKEND_BASEURL = process.env.REACT_APP_BACKEND_URL;
const baseUrl = `${BACKEND_BASEURL}api/users`;
export const getUser = async () => {
  const response = await axios.get(baseUrl + "/getUser");
  return response.data;
};
